import { getStore } from 'owa-mail-compose-store/lib/store/composeStore';
import { ICommandBarItemProps } from 'office-ui-fabric-react/lib/CommandBar';
import ComposeViewState from 'owa-mail-compose-store/lib/store/schema/ComposeViewState';
import protectMessage from 'owa-mail-compose-store/lib/actions/protectMessage';
import shouldDisableEncryptionButton from 'owa-mail-compose-store/lib/utils/shouldDisableEncryptionButton';

export default function(templateId: string, viewState: ComposeViewState): ICommandBarItemProps {
    if (shouldDisableEncryptionButton(viewState)) {
        return null;
    }

    const storeState = getStore();
    const { IRMData } = viewState;
    const { complianceConfigurations } = storeState;

    return {
        name: complianceConfigurations.get(templateId).TemplateName,
        onClick: () => {
            protectMessage(viewState, complianceConfigurations, templateId);
        },
        key: templateId,
        canCheck: true,
        checked: IRMData && IRMData.RmsTemplateId == templateId,
    };
}
